export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';
export const BACK_TO_LOGIN = 'BACK_TO_LOGIN';
export const LOGOUT = 'LOGOUT';

export const REFRESH_ACCESS = 'REFRESH_ACCESS';
export const REFRESH_ACCESS_SUCCESS = 'REFRESH_ACCESS_SUCCESS';
export const REFRESH_ACCESS_FAIL = 'REFRESH_ACCESS_FAIL';

const AuthConstants = {
    RESET_PASSWORD: 'AUTH__RESET_PASSWORD',
    RESET_PASSWORD_SUCCESS: 'AUTH__RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAIL: 'AUTH__RESET_PASSWORD_FAIL',

    REQUEST_RESET_PASSWORD: 'AUTH__REQUEST_RESET_PASSWORD',
    REQUEST_RESET_PASSWORD_SUCCESS: 'AUTH__REQUEST_RESET_PASSWORD_SUCCESS',
    REQUEST_RESET_PASSWORD_FAIL: 'AUTH__REQUEST_RESET_PASSWORD_FAIL',

    CHANGE_PASSWORD: 'AUTH__CHANGE_PASSWORD',
    CHANGE_PASSWORD_SUCCESS: 'AUTH__CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAIL: 'AUTH__CHANGE_PASSWORD_FAIL',

    LOGIN_WITH_TOKEN: 'AUTH__LOGIN_WITH_TOKEN',
    LOGIN_WITH_TOKEN_SUCCESS: 'AUTH__LOGIN_WITH_TOKEN_SUCCESS',
    LOGIN_WITH_TOKEN_FAIL: 'AUTH__LOGIN_WITH_TOKEN_FAIL',

    LOGIN_WITH_OAUTH: 'AUTH__LOGIN_WITH_OAUTH',
    LOGIN_WITH_OAUTH_SUCCESS: 'AUTH__LOGIN_WITH_OAUTH_SUCCESS',
    LOGIN_WITH_OAUTH_FAIL: 'AUTH__LOGIN_WITH_OAUTH_FAIL',
};

export default AuthConstants;
